import mutations from "./store/mutations";
import actions from "./store/actions";
import getters from "./store/getters";

/* Module */
const _module = {
    state: () => ({
        refreshQueued:      true,
        type:               'discover',
        membershipRequests: {},
        membershipClubsRequests: {},
        myMemberships:      {},
        clubTransitionEnabled : true,
        clubDates: {
            loading:  false,
            invited:  [],
            accepted: [],
            my_clubs: [],
            discover: [],
            discover_has_more: false
        },
        clubs_filter: {
            handle: ''
        },
        page: 0,
        source: {
            club: {
                visible: false,
                mode:    'view',
                clubId:  null
            },
        }
    }),
    actions,
    mutations,
    getters
}

export default _module
